import React from 'react';
import formConfig from "../../../formJsonData/Purchase/BranchMaster/BranchForm.json"
import Forms from '../../../components/common/Form';
const BranchForm = () => {
  return (
    <div>
       <Forms formConfig={formConfig}/>
    </div>
  )
}

export default BranchForm
